import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { AuthContext } from './../AuthContext';
import { site_url_img, site_url, invoice_img } from "./../config.js";
import axios from 'axios';
import { Link } from 'react-router-dom';
import { IndianCurrencyFormatter,FormatDate } from '../Function';
import './app.css';
import { useLocation,useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

function Index() {
  const { user } = useContext(AuthContext);
  const [data, setdata] = useState([]);
  const location = useLocation();
  const [staffAdvances, setStaffAdvances] = useState([]);
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(new Date().toISOString().split('T')[0]);
  const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    sid: '',
    amount: '',
    date: new Date().toISOString().split('T')[0],
    pay_type: 'debit'
  });

  useEffect(() => {
    console.log(user);
    // Set user ID in form data when user is available
    if (user?.id) {
      setFormData(prev => ({
        ...prev,
        sid: user.id
      }));
    }
    fetchWorkers();
    fetchStaffAdvances();
  },[user]);

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    console.log('logout');
    window.location.href = '/';
  };

  // Fetch workers list
  const fetchWorkers = async () => {
    try {
      const response = await axios.post(site_url + '/workers_list', {
        page: 1,
        limit: 1000,
        search: ''
      });
      if (response.data.status === 'success') {
        setWorkers(response.data.workers || []);
      }
    } catch (error) {
      console.error('Error fetching workers:', error);
    }
  };

  // Fetch staff advances with date filter
  const fetchStaffAdvances = async () => {
    setLoading(true);
    try {
      const response = await axios.post(site_url + '/staff-advance/list', {
        fromDate: fromDate,
        toDate: toDate
      });
      if (response.data.status === 'success') {
        setStaffAdvances(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching staff advances:', error);
      Swal.fire('Error', 'Failed to fetch staff advances', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submit (add or update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const endpoint = editingId ? '/staff-advance/update' : '/staff-advance/add';
      const payload = editingId 
        ? { ...formData, id: editingId }
        : formData;

      const response = await axios.post(site_url + endpoint, payload);
      
      if (response.data.status === 'success') {
        Swal.fire('Success', editingId ? 'Staff advance updated successfully' : 'Staff advance added successfully', 'success');
        resetForm();
        fetchStaffAdvances();
      } else {
        Swal.fire('Error', response.data.message || 'Operation failed', 'error');
      }
    } catch (error) {
      console.error('Error saving staff advance:', error);
      Swal.fire('Error', 'Failed to save staff advance', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      sid: user?.id || '',
      amount: '',
      date: new Date().toISOString().split('T')[0],
      pay_type: 'debit'
    });
    setEditingId(null);
    setShowForm(false);
  };

  // Handle edit
  const handleEdit = async (id) => {
    try {
      const response = await axios.get(site_url + `/staff-advance/edit/${id}`);
      if (response.data.status === 'success') {
        const advance = response.data.data;
        setFormData({
          sid: user?.id || advance.sid || '', // Always use current user ID
          amount: advance.amount || '',
          date: advance.date || new Date().toISOString().split('T')[0],
          pay_type: advance.pay_type || 'debit'
        });
        setEditingId(id);
        setShowForm(true);
      }
    } catch (error) {
      console.error('Error fetching advance details:', error);
      Swal.fire('Error', 'Failed to fetch advance details', 'error');
    }
  };

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2
    }).format(amount);
  };



  return (

    <div id="appCapsule">
    <div className="section mt-4">
              <div className="section-heading">
                
              
                
              </div>
              <div className="transactions">
                <center>
                <h2 className="title">Profile</h2>
                <div className="profile-card">
      <img src={'images (1).png'} alt="profile" className="profile-img" />
      <h2>{user?.w_name}</h2>
      <p>{user?.w_phone}</p>
      <p className="role">{user?.w_address}</p>
      <button className="edit-btn" onClick={handleLogout} >Logout</button>
    </div>
                </center>
           
             
                <div>
                  <div className="section-heading mb-3 mt-3">
                    <h2 className="title">Staff Advances</h2>
                    <button 
                      className="btn btn-primary btn-sm"
                      onClick={() => {
                        resetForm();
                        setShowForm(true);
                      }}
                    >
                      Add Staff Advance
                    </button>
                  </div>

                  {/* Add/Edit Form */}
                  {showForm && (
                    <div className="card mb-4">
                      <div className="card-body">
                        <h5 className="card-title">{editingId ? 'Edit' : 'Add'} Staff Advance</h5>
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label className="form-label">Staff</label>
                              <input
                                type="text"
                                className="form-control"
                                value={user?.w_name ? `${user.w_name} - ${user.w_phone}` : ''}
                                readOnly
                                disabled
                                style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                              />
                              <input
                                type="hidden"
                                name="sid"
                                value={user?.id || ''}
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="form-label">Amount</label>
                              <input
                                type="number"
                                name="amount"
                                value={formData.amount}
                                onChange={handleInputChange}
                                className="form-control"
                                step="0.01"
                                min="0"
                                placeholder="Enter Amount"
                                required
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="form-label">Date</label>
                              <input
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleInputChange}
                                className="form-control"
                                required
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="form-label">Payment Type</label>
                              <select
                                name="pay_type"
                                value={formData.pay_type}
                                onChange={handleInputChange}
                                className="form-control"
                                required
                              >
                                <option value="debit">Debit</option>
                              </select>
                            </div>
                          </div>

                          <div className="text-end">
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={resetForm}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={loading}
                            >
                              {loading ? 'Saving...' : (editingId ? 'Update' : 'Submit')}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  )}

                  {/* Date Filter */}
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>From Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={fromDate}
                              onChange={(e) => setFromDate(e.target.value)}
                              max={toDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>To Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={toDate}
                              onChange={(e) => setToDate(e.target.value)}
                              min={fromDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 d-flex align-items-end">
                          <button
                            className="btn btn-primary w-100"
                            onClick={fetchStaffAdvances}
                            disabled={!fromDate || !toDate || loading}
                          >
                            {loading ? 'Loading...' : 'Filter'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* History List */}
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Staff Advances History</h5>
                      {loading ? (
                        <div className="text-center">Loading...</div>
                      ) : staffAdvances.length === 0 ? (
                        <div className="text-center text-muted">No records found</div>
                      ) : (
                        <div className="table-responsive">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th>#</th>
                                {/* <th>Staff Name</th> */}
                                {/* <th>Staff Phone</th> */}
                                <th>Amount</th>
                                <th>Date</th>
                                <th>Payment Type</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {staffAdvances.map((advance, index) => {
                                const worker = workers.find(w => w.id == advance.sid);
                                return (
                                  <tr key={advance.id}>
                                    <td>{index + 1}</td>
                                    {/* <td>{worker ? worker.w_name : 'N/A'}</td>
                                    <td>{worker ? worker.w_phone : 'N/A'}</td> */}
                                    <td>{formatCurrency(advance.amount)}</td>
                                    <td>{advance.date}</td>
                                    <td>{advance.pay_type}</td>
                                    <td>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() => handleEdit(advance.id)}
                                      >
                                        Edit
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              
                
                
              </div>
            </div>
    

      <Footer />
      <Sidebar />
      
      


    </div>
  )
}

export default Index